import React from 'react'
import glamorous from 'glamorous'
import { smallAndSmaller } from 'lib/styles/media-queries'
import glamorousIcon from 'lib/glamorous-icon'
import clockIllustrationSvg from './svg/clock-illustration.svg'
import {
  getParagraphContent,
  getHeaderContent,
} from 'transfer/utils/risk-hold-utils'
import content from 'pp-react-l10n'
import PropTypes from 'prop-types'
const i18n = content('transfer/24-hour-holds/index')

export const Illustration = glamorousIcon({
  '& svg': {
    width: '6rem',
    marginBottom: '0.5rem',
  },
})

export const Container = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  textAlign: 'center',
  alignItems: 'center',
  margin: '0 5rem',
  [smallAndSmaller]: {
    margin: '0',
  },
  marginTop: '5rem',
})

export const Header = glamorous.h2({
  fontSize: '1.7rem',
  marginTop: '1rem',
  lineHeight: '2rem',
  [smallAndSmaller]: {
    fontSize: '1.5rem',
  },
})

export const Paragraph = glamorous.p({
  lineHeight: '1.25rem',
  margin: '0.5rem',
})

export function ClockIllustration() {
  return <Illustration svg={clockIllustrationSvg} />
}

export function HeaderContent({
  variant = '',
  displayName = '',
  recipient = '',
}) {
  const name = displayName ? displayName : recipient || i18n('header.they')
  return <Header>{getHeaderContent({ variant, name })}</Header>
}

HeaderContent.propTypes = {
  variant: PropTypes.string,
  recipient: PropTypes.string,
  displayName: PropTypes.string,
}

export function ParagraphContent(props) {
  const { style = {} } = props
  return (
    <Paragraph style={{ ...style }}>{getParagraphContent(props)}</Paragraph>
  )
}

ParagraphContent.propTypes = {
  variant: PropTypes.string.isRequired,
  style: PropTypes.object,
}
